import { Pipe, PipeTransform } from '@angular/core';
import { isNumber } from '@utils/util';

/**
 * Pipe that checks whether a given value is a valid number.
 *
 * This is a simple wrapper around a utility `isNumber` function, useful for inline
 * checks within templates.
 *
 * @example
 *   {{ value | isNumber }} <!-- true or false -->
 *
 * @see isNumber Utility Function
 */
@Pipe({
  name: 'isNumber',
  standalone: true,
})
export class IsNumberPipe implements PipeTransform {
  // type 'any' is suitable for this case
  transform(value: any): boolean {
    return isNumber(value);
  }
}
